import React from "react";
import Hero from "../components/home/Hero";
import AboutSnapshot from "../components/home/AboutSnapshot";
import ServicesSection from "../components/home/ServicesSection";
import GallerySection from "../components/home/GallerySection";
import WhyChooseUs from "../components/home/WhyChooseUs";
import PortfolioSection from "../components/home/PortfolioSection";
import ClientsPartners from "../components/home/ClientsPartners";
import ContactSection from "../components/home/ContactSection";
import TestimonialsSection from "../components/home/TestimonialsSection";
import { useApp } from "../context/AppContext";
import SEO from "../components/SEO";

const Home = () => {
  const { companyinfo } = useApp();
  return (
    <>
      <SEO
        title="Home"
        description="A social enterprise based in Ethiopia specializing in research, monitoring, and evaluation."
        keywords={[
          "research",
          "monitoring",
          "evaluation",
          "Ethiopia",
          "data analysis",
        ]}
        image={`${companyinfo?.logo}`}
        url="https://agoraconsulting-et.com"
      />
      <main className="bg-white">
        <Hero />
        <AboutSnapshot />
        <ServicesSection />
        {/* <GallerySection /> */}
        <WhyChooseUs />
        <PortfolioSection />
        <ClientsPartners />
        {/* <TestimonialsSection /> */}
        <ContactSection />
      </main>
    </>
  );
};

export default Home;
